export const PackageType = Object.freeze({
  ThickEnvelope: '2',
  StandardPackage: '3',
});
